<template>
  <div class="system-ads">
    <Search @filter-ads="applyFilters" />

    <a-g-speakol-table ref="systemAdsTable" :filters="agFilters" :columns="agColumns" :options="agOptions"></a-g-speakol-table>
  </div>
</template>

<script>
import SystemAdsDataSource from '@/datasources/SystemAdsDataSource'

import AGSpeakolTable from '@/components/AGSpeakolTable'

import Search from './components/Search'

import AdsActionsMenu from './components/AdsActionsMenu'

import AdStatus from './components/AdStatus'

import CampaignColumn from './components/campaign-col'

import CreatedAtColumn from '@/views/campaigns/index/components/AgTableComponents/CreatedAt.vue'
import { getDateAndTimeFromDateTimeString } from '@/filters/Dates'

export default {
  components: {
    Search,
    AdStatus,
    AGSpeakolTable,
    AdsActionsMenu,
    CampaignColumn,
    CreatedAtColumn
  },
  data () {
    return {
      agOptions: this.getTableOptions(),
      agColumns: this.getTableColumns(),
      agFilters: this.getTableFilters()
    }
  },
  methods: {
    getTableFilters () {
      return {
        page: 1,
        title: null,
        status: null,
        manager_id: null,
        advertiser_id: null,
        campaign_id: null,
        accountsIds:null,
        deliveringStatus: null
      }
    },
    getTableOptions () {
      return {
        dataSource: SystemAdsDataSource
      }
    },
    getTableColumns () {
      return [
        {
          headerName: 'ID',
          field: 'id',
          minWidth: 100
        },
        {
          headerName: 'Ad Title',
          field: 'title',
          minWidth: 400
        },
        {
          headerName: 'Campaign Name',
          field: 'campaign_name',
          minWidth: 360,
          autoHeight: true,
          cellRendererFramework: 'CampaignColumn'
        },
        {
          headerName: 'Created Date',
          field: 'created_at',
          minWidth: 180,
          sortable: true,
          valueGetter (params) {
            if (params.data && params.data.created_at) {
              return getDateAndTimeFromDateTimeString(params.data.created_at)
            }

            return 'N/A'
          },
          cellRendererFramework: 'CreatedAtColumn'
        },
        {
          headerName: 'Advertising Channel',
          field: 'advertising_channel',
          minWidth: 210,
          valueGetter (params) {
            if (params.data) {
              return params.data.advertising_channel_title || 'N/A'
            }
          }
        },
        {
          headerName: 'Type',
          field: 'campaign_type',
          minWidth: 200,
          valueGetter (params) {
            if (params.data) {
              return params.data.campaign_type || 'N/A'
            }
          }
        },
        {
          headerName: 'Objective',
          field: 'campaign_objective',
          minWidth: 170,
          valueGetter (params) {
            if (params.data) {
              return params.data.campaign_objective || 'N/A'
            }
          }
        },
        {
          headerName: 'Advertiser\'s Email',
          field: 'user_email',
          minWidth: 300
        },
        {
          headerName: 'Status',
          field: 'aggregated_status',
          minWidth: 140,
          cellRendererFramework: 'AdStatus'
        },
        {
          headerName: 'Account Manager',
          field: 'account_manager',
          minWidth: 220,
          valueGetter (params) {
            if (params.data) {
              return params.data.account_manager || 'N/A'
            }
          }
        },
        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 220,
          cellRendererFramework: 'AdsActionsMenu'
        }
      ]
    },

    applyFilters (filters) {
      this.agFilters.page = 1
      this.agFilters.title = filters.title
      this.agFilters.status = filters.status
      this.agFilters.manager_id = filters.manager || null
      this.agFilters.advertiser_id = filters.advertiser || null
      this.agFilters.deliveringStatus = filters.deliveringStatus || null
      this.agFilters.campaign_id = filters.campaign || null
      this.agFilters.accountsIds = filters.accountId ? [filters.accountId] : null
      this.agFilters.objective = filters.objective ? [filters.objective] : null
      this.agFilters.type = filters.type ? [filters.type] : null

      this.$refs['systemAdsTable'].applyFilters()
    }
  }
}
</script>

<style lang="scss">

.ag-cell-wrapper {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.system-campaigns {
  .speakol-table-filter-button {
    width: 135px;
  }

  .speakol-export-button {
    background-color: white !important;
    color: #0092d7;
    border: 1px solid #0092d7;
    width: 135px;
    border-radius: 3px;
    padding: 8px 20px !important;
  }
}

.vue-tabs .nav > li > a:hover,
.vue-tabs .nav > li > a:focus {
  background-color: transparent !important;
}

.tab.active h4 {
  font-weight: 500 !important;
}

.vue-treeselect__control {
  height: 38px;
}

.vs-input--input.hasIcon {
  border: 1px solid #cfcfcf !important;
}

.vs-input--input.hasIcon:focus {
  box-shadow: none !important;
}

.speakol-table-input .vs-con-input .vs-icon {
  color: #cfcfcf !important;
}

.admin-table-mobile-version {
  display: none;
}

@media (max-width: 768px) {
  .admin-table-mobile-version {
    display: block;
  }

  .admin-table-desktop-version {
    display: none;
  }
}

.campaign-name {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 150px;
  white-space: nowrap;
}

.system-ads {
  .status-span {
    color: black;
  }
}
</style>
